import { render, staticRenderFns } from "./CompanyLocalisationsCard.vue?vue&type=template&id=07d86a37"
import script from "./CompanyLocalisationsCard.vue?vue&type=script&lang=js"
export * from "./CompanyLocalisationsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports